import { clientPublicStore } from "@packages/stores";
import { Pages } from "@packages/utils/enums";
import type { Passport } from "@src/Passport";
import type { TCredenzaClientTokenConfig } from "@packages/utils/types";
import { get } from "svelte/store";

export const getClientTokenConfig = (): TCredenzaClientTokenConfig =>
  get(clientPublicStore)?.client_payment_configuration?.token ?? DEFAULT_CONFIG;

export const getStripePublishableKey = (): string | null =>
  get(clientPublicStore)?.client_payment_configuration?.stripe_publishable_key ??
  null;

const DEFAULT_CONFIG: TCredenzaClientTokenConfig = {
  name: "DEFAULT",
  minStoredValueToPurchase: 0,
  maxStoredValueToPurchase: 100,
  payment: {
    stripe: "USD",
  },
};

export const getClientSettings = async (apiUrl: string, clientId: string) => {
  const result = await fetch(`${apiUrl}/clients/${clientId}/public`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const json = await result.json();
  if (!result.ok) throw new Error(json.error);
  json.ui_settings = Object.assign(
    { stored_value_alias: "stored value", cred_alias: "CRED" },
    json.ui_settings,
  );

  return json;
};

export const openClientWelcomMessage = (openUI: Passport["openUI"]) => {
  const {
    ui_settings: { welcome_title, welcome_text },
  } = get(clientPublicStore);
  if (!welcome_title && !welcome_text) return;

  openUI(Pages.WELCOME);
};
